import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import ReputationQuizContainer from "./ReputationQuizContainer";
import ReputationResults from "./ReputationResults";

const ReputationQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            subtitle="Build Trust That Drives Business"
            onSubmit={handleUserInfoSubmit}
          />
        }
      />
      <Route
        path="quiz"
        element={<ReputationQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<ReputationResults />} />
    </Routes>
  );
};

export default ReputationQuiz;
